module.exports = ".angular-treeview .wrapper-all {\r\n    width: 100%;\r\n}\r\n\r\n.angular-treeview i.fa {\r\n    font-size: 16px!important;\r\n    width: 10px!important;\r\n    margin-right: 3px!important;\r\n}\r\n\r\n.angular-treeview {\r\n    padding: 5px 0px;\r\n}\r\n\r\n.angular-treeview.with-border {\r\n    padding: 5px 0px 5px 10px;\r\n    border: 1px inset lightgray;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/angular_library/components/treeview/treeview.css
// module id = ./src/angular_library/components/treeview/treeview.css
// module chunks = main